import src from "IMAGE";
export default { src, width: 200, height: 200, blurWidth: 0, blurHeight: 0};
